import { gql } from '@apollo/client';

import { dashboardFields } from './constants';

export const GET_TRQK_STATEMENT_VIEW_AUTHENTICATED = gql`
    query getTrqkStatementView($id: ID!, $version: Float!) {
        getTrqkStatementView(id: $id, version: $version) {
            view {
                ${dashboardFields}
            }
        }
    }
`;
